import { useState, useEffect } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { verifyEmail } from '@/api/http/auth-api'
import { extractErrorMessage } from '@/api/http/errors'

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setMessage('Отсутствует токен подтверждения')
      return
    }
    verifyEmail(token)
      .then(() => {
        setStatus('success')
        setMessage('Email успешно подтверждён! Теперь вы можете войти в систему.')
      })
      .catch((err) => {
        setStatus('error')
        setMessage(extractErrorMessage(err, 'Ошибка подтверждения email'))
      })
  }, [token])

  return (
    <div className="flex items-center justify-center min-h-dvh p-4">
      <div className="max-w-sm mx-auto w-full">
        <div className="flex flex-col items-center mb-8">
          <div className={`flex items-center justify-center w-12 h-12 rounded-xl mb-4 ${
            status === 'loading' ? 'bg-accent/10 text-accent' :
            status === 'success' ? 'bg-green-soft text-green' :
            'bg-destructive/10 text-destructive'
          }`}>
            {status === 'loading' && <Loader2 className="w-6 h-6 animate-spin" strokeWidth={2} />}
            {status === 'success' && <CheckCircle2 className="w-6 h-6" strokeWidth={2} />}
            {status === 'error' && <XCircle className="w-6 h-6" strokeWidth={2} />}
          </div>
          <h1 className="text-xl font-semibold text-text">
            {status === 'loading' ? 'Подтверждение email' :
             status === 'success' ? 'Email подтверждён' :
             'Ошибка подтверждения'}
          </h1>
          <p className="text-sm text-text-muted mt-1 text-center">{message}</p>
        </div>

        {status !== 'loading' && (
          <Link to="/login">
            <Button className="w-full gap-2" size="lg">
              {status === 'success' ? 'Войти в систему' : 'На страницу входа'}
            </Button>
          </Link>
        )}
      </div>
    </div>
  )
}
